import { Job } from "@/modules/types/job/job";
import { create } from "zustand";

interface savedJobStore {
  status: "idle" | "loading" | "success" | "error";
  savedJobs: Job[];
  total: number;
  nextId?: string;
  setStatus: (status: "idle" | "loading" | "success" | "error") => void;
  setSavedJobs: (savedJobs: Job[], total: number, nextId?: string) => void;
  addSavedJob: (job: Job) => void;
  removeSavedJob: (jobId: string) => void;
  clearSavedJobs: () => void;
  isJobSaved: (jobId: string) => boolean;
}

export const useSavedJobStore = create<savedJobStore>((set, get) => ({
  status: "idle",
  savedJobs: [],
  total: 0,
  nextId: undefined,
  setStatus: (status) => set({ status }),
  setSavedJobs: (savedJobs, total, nextId) => set({ savedJobs, total, nextId }),
  addSavedJob: (job) =>
    set((state) => ({
      savedJobs: [...state.savedJobs, job],
      total: state.total + 1,
    })),
  removeSavedJob: (jobId) =>
    set((state) => ({
      savedJobs: state.savedJobs.filter((job) => job.id !== jobId),
      total: Math.max(0, state.total - 1),
    })),
  clearSavedJobs: () => set({ savedJobs: [], total: 0, nextId: undefined }),
  isJobSaved: (jobId) => {
    const state = get();
    return state.savedJobs.some((job) => job.id === jobId);
  },
}));
